/* unplugin-vue-components disabled */import script from "./SubmitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitModal.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitModal.vue?vue&type=style&index=0&id=0e04293a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e04293a"]])

export default __exports__